import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Page,
  PageSettingsModel,
  Resize,
  Sort,
  Inject,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import * as React from 'react';
import {all_information, loadingShow} from '../../App';
import Message from '../../utils/Message/Message';
import './style.css';
import {
  AddPlan,
  DeletePlan,
  DeletePlanOrder,
  EditPlan,
  getOrderByPlan,
  getPlan,
} from '../../services/ControlCenter/PlanServices';
import GlobalPlannedOrderGrid from '../../components/GlobalPlannedOrderGrid';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GetCloudExecutionOperationDatasByPlan } from '../../utils/CreateRequest';
import { UpdateBreakInType } from '../../utils/Types/types';
import { updateBreakIn } from '../../services/CloudExecutionServices/CloudExecutionService';
interface IProps {
  plan_id: number;
}
let ERP_TYPE = ''//GetErpTypeFromConfig();
const erpTypeName = 'MEX';

const toolbarOptionsBreakIn = [
  {
    text: 'Refresh',
    tooltipText: 'Refresh',
    prefixIcon: 'e-refresh',
    id: 'refresh',
  },
  {
    text: 'Remove BreakIn',
    tooltipText: 'Remove BreakIn',
    prefixIcon: 'e-arrow-up',
    id: 'remove_break_in',
  },
  // {
  //   text: 'Assign Work Orders',
  //   tooltipText: 'Add',
  //   prefixIcon: 'e-add',
  //   id: 'add',
  // },
  'Search',
];
const FilterOptions: FilterSettingsModel = { type: 'Menu' };
const pageOptions: PageSettingsModel = {
  currentPage: 1,
  pageSize: 50,
  pageCount: 10,
  pageSizes: false,
};
var buttons: ButtonPropsModel[];
let gridPlannedOperationsObj: GridComponent;
let gridBreakInOperationsObj: GridComponent;
let txtPlanName = '';
let txtPlanDescription = '';
let planID = -1;
let status: boolean = false;
const animationSettings: AnimationSettingsModel = {
  effect: 'Zoom',
  duration: 400,
  delay: 0,
};
gridBreakInOperationsObj = new GridComponent({});
gridPlannedOperationsObj = new GridComponent({});
const toolbarOptions: any = [
  {
    text: 'Refresh',
    tooltipText: 'Refresh',
    prefixIcon: 'e-refresh',
    id: 'refresh',
  },
  {
    text: 'Assign BreakIn',
    tooltipText: 'Assign BreakIn',
    prefixIcon: 'e-arrow-down',
    id: 'assign_break_in',
  },
  'Search',
];
const PlannedOperations = ({ plan_id }: IProps) => {
  let timezone_offset = useSelector(
    (state: any) => state.search.timezone_offset
  );
  const [operationsByPlanData, setOperationsByPlanData] = React.useState<Array<any>>([]);
  const [breakInOperationsByPlanData, setBreakInOperationsByPlanData] = React.useState<Array<any>>([]);
  const [planOrderData, setPlanOrderData] = React.useState<Array<any>>([]);
  const [hideDialog, setHideDialog] = React.useState<boolean>(false);
  const [hideDialogOrder, setHideDialogOrder] = React.useState<boolean>(false);
  const [dtStartDate, setDtStartDate] = React.useState<Date>(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );
  const [dtEndDate, setDtEndDate] = React.useState<Date>(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
  );
  buttons = [
    {
      click: () => {
        savePoint();
      },
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      },
    },
    {
      click: () => setHideDialog(false),
      buttonModel: {
        content: 'Close',
      },
    },
  ];

  const getPlanOrder = async (plan_id: any) => {
    await getOrderByPlan(
      `1$500$ {"f":"ID","c":"=","t":"where","v":"${plan_id}"}`,
      timezone_offset
    )
      .then((res) => {
        let model = res.data.map((items: any) => {
          return {
            ...items,
            organization_code: all_information.companyName,
            order_code: items.order_code,
            ID: items.plan_order_id,
            comesFromPlan: true,
          };
        });
        loadingShow(false);
        setPlanOrderData(model);
      })
      .catch((error) => {
        console.log(error);
        loadingShow(false);
      });
  };
  const getTheOperationsByPlan = (id: number) => {
    GetCloudExecutionOperationDatasByPlan(id, false).then((result: any) => {
      let planOrder = result.length > 0 ? planOrderData : [];
      setOperationsByPlanData(result);
      setPlanOrderData(planOrder);
    });
  };
  const getTheBreakInOperationsByPlan = (id: number) => {
    GetCloudExecutionOperationDatasByPlan(id, true).then((result: any) => {
      let planOrder = result.length > 0 ? planOrderData : [];
      setBreakInOperationsByPlanData(result);
    });
  };
  const savePoint = () => {
    const sDate = new Date(dtStartDate).getTime();
    const eDate = new Date(dtEndDate).getTime();

    if (txtPlanName === '') {
      Message.error('Can not be empty plan name');
      return false;
    }
    if (txtPlanDescription === '') {
      Message.error('Can not be empty description');
      return false;
    }
    if (sDate === 0) {
      Message.error('Can not be empty start date');
      return false;
    }
    if (eDate === 0) {
      Message.error('Can not be empty end date');
      return false;
    }
    loadingShow(true);
  };

  const toolbarClick = async (args: any) => {
    if (args.item.id === 'refresh') {
      gridPlannedOperationsObj.showSpinner();
      await getTheOperationsByPlan(plan_id);
      gridPlannedOperationsObj.hideSpinner();
    }
    if (args.item.id === 'assign_break_in') {
      const selectedRecords = gridPlannedOperationsObj.getSelectedRecords();

      if (selectedRecords.length === 0) {
        Message.error('No records selected to assign operation');
        return;
      }
      gridPlannedOperationsObj.showSpinner();
      const datas: UpdateBreakInType[] = selectedRecords.reduce((acc: UpdateBreakInType[], item: any) => {
        acc.push({ operationId: item.operationId, isBreakIn: true });
        return acc;
      }, []);

      if (datas.length > 0) {
        try {
          await updateBreakIn(datas);
          gridPlannedOperationsObj.hideSpinner();
        } catch (error) {
          Message.error('Failed to assign break-in operation');
          console.error(error);
        }
      }
      setOperationsByPlanData([]);
      getTheOperationsByPlan(plan_id);
      getTheBreakInOperationsByPlan(plan_id);
    }
  };

  const toolbarClickOrder = async (args: any) => {
    if (args.item.id === 'refresh') {
      getTheBreakInOperationsByPlan(plan_id);
    }
    if (args.item.id === 'remove_break_in') {
      const selectedRecords = gridBreakInOperationsObj.getSelectedRecords();

      if (selectedRecords.length === 0) {
        Message.error('No records selected to remove operation');
        return;
      }
      gridBreakInOperationsObj.showSpinner();
      const datas: UpdateBreakInType[] = selectedRecords.reduce((acc: UpdateBreakInType[], item: any) => {
        acc.push({ operationId: item.operationId, isBreakIn: false });
        return acc;
      }, []);

      if (datas.length > 0) {
        try {
          await updateBreakIn(datas);
          gridBreakInOperationsObj.hideSpinner();
        } catch (error) {
          Message.error('Failed to assign break-in operation');
          console.error(error);
        }
      }
      setBreakInOperationsByPlanData([]);
      getTheBreakInOperationsByPlan(plan_id);
      getTheOperationsByPlan(plan_id);
    }
  };
  const deleteOrderPlan = async (
    obj: any,
    plan_id: number,
    fetchData: boolean
  ) => {
    await DeletePlanOrder(obj)
      .then((res: any) => {
        Message.success('Success');
        if (fetchData) {
          getPlanOrder(plan_id);
        }
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const closeDialog = () => {
    cleanForInput();
    setHideDialog(false);
  };
  const cleanForInput = () => {
    txtPlanName = '';
    txtPlanDescription = '';
    setDtStartDate(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    setDtEndDate(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    );
    setHideDialog(false);
  };
  const rowSelectPlan = async (args: any) => {
    let selRecord: any = args.data;
    planID = selRecord.ID;
    loadingShow(true, 'Please wait.');
    await getPlanOrder(selRecord.ID);
  };

  const templateStatusPlan = (args: any) => {
    return (
      <div>
        {!args.status || args.status === null ? (
          <span>Waiting for Approve</span>
        ) : (
          <span>Ready for Scheduling</span>
        )}
      </div>
    );
  };
  useEffect(() => {
    const getData = async () => {
      //await getThePlan(event_id);
    };
    getData();
    return () => { };
  }, []);
  useEffect(() => {
    getTheOperationsByPlan(plan_id);
    getTheBreakInOperationsByPlan(plan_id);
  }, [plan_id]);

  return (
    <div className='control-center-plan'>
      <div className='plan-grid-1'>
        <GridComponent
          id='gridEventPlan'
          dataSource={operationsByPlanData}
          toolbar={toolbarOptions}
          ref={(g: GridComponent) => (gridPlannedOperationsObj = g)}
          filterSettings={FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={pageOptions}
          toolbarClick={toolbarClick.bind(this)}
          showColumnMenu={true}
          allowResizing={true}
          style={{ marginTop: '10px' }}
          gridLines='Both'
          //rowSelected={rowSelectPlan.bind(this)}
          width={window.innerWidth - 150}
          height='25vh'
          allowSelection={true}
          selectionSettings={{
            type: 'Multiple',
          }}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='operationID'
              headerText='operationID'
              textAlign='Left'
              isPrimaryKey={true}
              visible={false}
            />
            <ColumnDirective
              field='assetNo'
              headerText='Asset No'
              width='125'
              textAlign='Left'
              type='string'
            />
            <ColumnDirective
              field='assetDescription'
              headerText='Asset Description'
              type='string'
            />
            <ColumnDirective
              field='orderCode'
              headerText='Order #'
              type='string'
              width='100'
            />
            <ColumnDirective
              field='priority'
              headerText='Priority'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='jobType'
              headerText='Job Type'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='responsibility'
              headerText='Responsibility'
              type='string'
              width='80'
            />
            <ColumnDirective
              field='status'
              headerText='Date'
              type='string'
            />
            <ColumnDirective
              field='operation_sequence'
              headerText='Task #'
              type='number'
              width='60'
            />
            <ColumnDirective
              field='operationDescription'
              headerText='Operation Description'
              type='string'
            />
            <ColumnDirective
              field='tradeCode'
              headerText='Trade'
              type='string'
            />
            <ColumnDirective
              field='required'
              headerText='Req'
              type='number'
            />
            <ColumnDirective
              field='estHours'
              headerText='Est Hours'
              type='number'
            />
            <ColumnDirective
              field='teamCode'
              headerText='Team'
              type='string'
            />
            <ColumnDirective
              field='status'
              headerText='Trades Assign'
              type='string'
            />
            <ColumnDirective
              field='shift'
              template={templateStatusPlan.bind(this)}
              headerText='Shit'
              type='string'
            />
            <ColumnDirective
              field='plannedStart'
              headerText='Planned Start'
              type='string'
            />
            <ColumnDirective
              field='status'
              headerText='SMU'
              type='string'
            />
            <ColumnDirective
              field='status'
              headerText='Done'
              type='string'
              width='60'
            />
            <ColumnDirective
              field='status'
              headerText='Compliance'
              type='string'
            />
          </ColumnsDirective>
          <Inject
            services={[Toolbar, Page, Resize, Filter, Sort, ColumnMenu]}
          />
        </GridComponent>
      </div>
      <div id='plan-grid-2' style={{ marginTop: 20 }}>
        <label style={{ fontSize: '18px' }}>BREAK IN OPERATIONS</label>
        <GridComponent
          id='gridPlans'
          dataSource={breakInOperationsByPlanData}
          toolbar={toolbarOptionsBreakIn}
          ref={(g: GridComponent) => (gridBreakInOperationsObj = g)}
          filterSettings={FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          style={{ marginTop: '10px' }}
          toolbarClick={toolbarClickOrder.bind(this)}
          gridLines='Both'
          width={'100%'}
          height='25vh'
          selectionSettings={{
            type: 'Multiple',
            persistSelection: true,
          }}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='operationID'
              headerText='operationID'
              textAlign='Left'
              isPrimaryKey={true}
              visible={false}
            />
            <ColumnDirective
              field='assetNo'
              headerText='Asset No'
              width='125'
              textAlign='Left'
              //isPrimaryKey={true}
              type='string'
            />
            <ColumnDirective
              field='assetDescription'
              headerText='Asset Description'
              type='string'
            />
            <ColumnDirective
              field='orderCode'
              headerText='Order #'
              type='string'
              width='100'
            />
            <ColumnDirective
              field='priority'
              headerText='Priority'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='jobType'
              headerText='Job Type'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='responsibility'
              headerText='Responsibility'
              type='string'
              width='80'
            />
            <ColumnDirective
              field='status'
              headerText='Date'
              type='string'
            />
            <ColumnDirective
              field='operation_sequence'
              headerText='Task #'
              type='number'
              width='60'
            />
            <ColumnDirective
              field='operationDescription'
              headerText='Operation Description'
              type='string'
            />
            <ColumnDirective
              field='tradeCode'
              headerText='Trade'
              type='string'
            />
            <ColumnDirective
              field='required'
              headerText='Req'
              type='number'
            />
            <ColumnDirective
              field='estHours'
              headerText='Est Hours'
              type='number'
            />
            <ColumnDirective
              field='teamCode'
              headerText='Team'
              type='string'
            />
            <ColumnDirective
              field='status'
              headerText='Trades Assign'
              type='string'
            />
            <ColumnDirective
              field='shift'
              template={templateStatusPlan.bind(this)}
              headerText='Shit'
              type='string'
            />
            <ColumnDirective
              field='plannedStart'
              headerText='Planned Start'
              type='string'
            />
            <ColumnDirective
              field='status'
              headerText='SMU'
              type='string'
            />
            <ColumnDirective
              field='status'
              headerText='Done'
              type='string'
              width='60'
            />
            <ColumnDirective
              field='status'
              headerText='Compliance'
              type='string'
            />
          </ColumnsDirective>
          <Inject
            services={[Toolbar, Page, Resize, Filter, Sort, ColumnMenu]}
          />
        </GridComponent>
      </div>
      <div className='popup-control-center-plan'>
        <DialogComponent
          isModal={true}
          id='defaultdialogControlCenterPlan'
          showCloseIcon={true}
          animationSettings={animationSettings}
          visible={hideDialog}
          width={'600px'}
          height={'450px'}
          header='Plan'
          buttons={buttons}
          open={() => setHideDialog(true)}
          close={closeDialog.bind(this)}
        >
          <div className='plan-input-controlcenter'>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <TextBoxComponent
                  placeholder='Plan Name'
                  value={txtPlanName}
                  floatLabelType='Always'
                  onChange={(e: any) => {
                    txtPlanName = e.target.value;
                  }}
                />
              </div>
            </div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <TextBoxComponent
                  placeholder='Plan Description'
                  floatLabelType='Always'
                  id='planDesc'
                  value={txtPlanDescription}
                  onChange={(e: any) => {
                    txtPlanDescription = e.target.value;
                  }}
                />
              </div>
            </div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <DatePickerComponent
                  id='planSDate'
                  floatLabelType='Always'
                  placeholder='Plan Start Date'
                  value={dtStartDate}
                  format='dd/MM/yyyy'
                  onChange={(e: any) => {
                    setDtStartDate(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <DatePickerComponent
                  placeholder='Plan End Date'
                  id='planEDate'
                  floatLabelType='Always'
                  value={dtEndDate}
                  format='dd/MM/yyyy'
                  onChange={(e: any) => {
                    setDtEndDate(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className='col-md-12'>Status</div>
            <div className='input-group-plan'>
              <div className='col-md-12'>
                <SwitchComponent
                  change={(e: any) => {
                    status = e.checked;
                  }}
                  checked={status}
                />
              </div>
            </div>
          </div>
        </DialogComponent>
      </div>
      <div className='popup-control-center-plan'>
        {hideDialogOrder ? (
          <GlobalPlannedOrderGrid

            hideDialogOrder={hideDialogOrder}
            setHideDialogOrder={(val: boolean) => setHideDialogOrder(val)}
            getPlanOrder={getPlanOrder.bind(this)}
            plan_id={planID}
          />
        ) : null}
      </div>
    </div>
  );
};
export default PlannedOperations;
